module.exports = __webpack_public_path__ + "img/oldman_landing_5.b04f0cb5.png";